<template>
  <div class="question-wrap">
    <div class="question-content">
      <div class="question-container">
        <div class="qc-version" v-if=" ['simple','question'].includes(getRequestType) " style="position: absolute;color: #3a8ee6;cursor: pointer;top: 5px;left: 2px;z-index: 9999">
          <label v-if="getRequestType === 'simple'"  @click="changeModel()">高级版</label>
          <label v-if="getRequestType === 'question'" @click="changeModel()">简易版</label>
          <div  class="canvas-disabled-switch">
            <span>显示推理图谱</span>
            <ElSwitch v-model="visionCommunicationEnabled"></ElSwitch>
          </div>
        </div>

        <h1 class="question-title">智能公共法律服务系统（民法典婚姻家庭编版）
          <el-popover placement="left-end" title="" width="400" trigger="hover">
            <div class="step-wrap">
              <div class="step-title">
                <img src="../../static/img/step.png" alt=""/>
                <h4>步骤流程</h4>
              </div>
              <div class="step-content">
                <img src="../../static/img/line.png" alt=""/>
                <ul>
                  <li>
                    <div class="step-content-left">
                      <h5>01</h5>
                    </div>
                    <div class="step-content-right">
                      <p>用户输入需要咨询的问题</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>02</h5>
                    </div>
                    <div class="step-content-right">
                      <p>系统自动给出问题分类与关键事实信息</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>03</h5>
                    </div>
                    <div class="step-content-right">
                      <p>需要额外信息，系统交互式对用户进行提问</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>04</h5>
                    </div>
                    <div class="step-content-right">
                      <p>系统根据事实进行推理，得到所需问题答案</p>
                    </div>
                  </li>
                  <li>
                    <div class="step-content-left">
                      <h5>05</h5>
                    </div>
                    <div class="step-content-right">
                      <p>结果以咨询报告的形式向用户呈现</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <el-button type="text" slot="reference">步骤流程</el-button>
          </el-popover>
        </h1>

<!--        <div class="new-question-body" v-show="getRequestType === 'question'">-->
<!--          <table style="width: 100%;height: 100%">-->
<!--            <tr style="margin-bottom: 20px">-->
<!--              <td style="width: 40vw;margin-bottom: 10px">-->
<!--                <div class="question-body-left-wrap">-->
<!--                  <h5>样例问题:</h5>-->
<!--                  <div class="question-example-wrap">-->
<!--                    <div class="question-example-item" v-for="(item, index) in exampleList" :key="index" @click="chooseExample(index)">-->
<!--                      <p>{{item}}</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--              <td style="width: 40vw">-->
<!--                <div class="question-body-right-th">-->
<!--                  <div class="question-content-top">-->
<!--                    <el-input type="textarea" :rows="6" placeholder="请输入您的法律问题" v-model="questionData.prologue" style="color: #333; font-size: 16px;"></el-input>-->
<!--                    <el-button type="primary" size="small" @click="getDomainsFunc">立即咨询</el-button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              &lt;!&ndash;使用draggable组件&ndash;&gt;-->
<!--                <td style="width: 40vw;height:25vh;margin-top: 10px;padding-top: 10px">-->
<!--                  <ul class="pagination">-->
<!--                    <li v-for="(p,index) in domains" :key="index" style="display: inline;">-->
<!--                      <label class="domainsLabel" v-if="currentTagIndex===p.id" v-on:click="setCurrent(p)" style="background-color: dodgerblue;color: white;"> {{ p.name }} </label>-->
<!--                      <label class="domainsLabel" v-else v-on:click="setCurrent(p)"> {{ p.name }} </label>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                  <draggable currentTagIndex.sync="currentTagIndex" v-model="domains[currentTagIndex].facts" :scroll="true" :forceFallback="true" group="site"-->
<!--                             animation="300" dragClass="dragClass"  ghost-class="ghostClass"-->
<!--                             chosenClass="chosenClass" @start="onStart" @end="onEnd" style="height: 25vh;max-height: 25vh;">-->
<!--                    <transition-group style="height: 25vh;width: 40vw;display: inline-block;overflow: auto">-->
<!--                      <div v-for="(item,index) in domains[currentTagIndex].facts" :key="index" class="item">-->
<!--                        <img v-if="currentClickTag!==item.id" class="card" style="" v-bind:src="item.image"/>-->
<!--                        <label v-if="currentClickTag!==item.id">{{item.sub_text}}</label>-->
<!--                      </div>-->
<!--                    </transition-group>-->
<!--                  </draggable>-->
<!--                </td>-->
<!--                <td  style="flex: 1;">-->
<!--                  <div class="fact-div">-->
<!--                    <div class="title" >正确事实</div>-->
<!--                    <draggable v-model="selectedTags" filter=".forbid" disable="false" group="site"-->
<!--                               animation="300" dragClass="dragClass1" ghost-class="ghostClass1"-->
<!--                               chosenClass="chosenClass1" @start="onStart" @end="onEnd" class="fact_drag">-->
<!--                      <transition-group class="fact-container">-->
<!--                        <label style="white-space:nowrap" class="tag" v-for="(item, index) in selectedTags" :key="index" v-on:click="moveToArr1(item)">{{item.sub_text + ' ×'}}</label>-->
<!--                      </transition-group>-->
<!--                    </draggable>-->
<!--                  </div>-->
<!--                  <div class="fact-div">-->
<!--                    <div class="title" >错误事实</div>-->
<!--                    <draggable v-model="unSelectedTags" filter=".forbid" disable="false" group="site"-->
<!--                               animation="300" dragClass="dragClass" ghost-class="ghostClass"-->
<!--                               chosenClass="chosenClass" @start="onStart" @end="onEnd" class="fact_drag">-->
<!--                      <transition-group class="fact-container">-->
<!--                        <label style="white-space:nowrap" class="tag forbid" v-for="(item, index) in unSelectedTags" :key="index" v-on:click="moveToArr1(item)">{{item.sub_text + ' ×'}}</label>-->
<!--                      </transition-group>-->
<!--                    </draggable>-->
<!--                  </div>-->
<!--                </td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <label class="next-step" v-on:click="chooseDomainItem">下一步></label>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </div>-->
<!--        简略版-->
        <p id="questionHint" v-show="getRequestType === 'simple'">请先录入您要咨询的内容，点击分析问题，出结果后可点击下一步进行咨询。</p>
        <div class="simple-question-body" v-show="getRequestType === 'simple'">
          <div class="question-content-top">
            <textarea placeholder="输入您需要咨询的问题" v-model="questionData.prologue" style="padding:10px;border:1px solid lightgray;width:100%;height:20vh;color: #333; font-size: 16px;"></textarea>
            <div style="padding-left: 25px">
              <el-button style="margin-top: 5px;font-size: 16px;padding-top: 10px;padding-bottom: 10px" @click="getDomainsFunc">分析问题</el-button>
            </div>
          </div>
          <div style="width: 60vw;align-items: center; height: 100%;display:flex; justify-content:center">
            <div class="simple-subdomains-container">
              <div v-if="simpleSubdomains.length > 0" v-for="(p,index) in simpleSubdomains" :key="index" class="simpleSubdomiansDiv">
                <div style="margin-right: 5px;position: absolute;right: 50.5%;display: flex;flex-direction: row">
<!--                  百分比柱状图显示-->
                  <label v-if="Math.floor(p.prob * 100) / 100 !== 0" style="margin-right: 5px">{{Math.floor(p.prob * 100).toString() + '%'}}</label>
                  <svg-bar type="rect" :value="100-Math.sqrt((p.prob))*100" :options="svgOptions" ></svg-bar>
                </div>
                <el-checkbox  @change="changeSubdomainItem(p.name)" v-if="p.check" :v-model="true" :checked="true" style="position: absolute;left: 50.5%"><span>{{p.name}}</span></el-checkbox>
                <el-checkbox  @change="changeSubdomainItem(p.name)" v-else :v-model="false" :checked="false" style="position: absolute;left: 50.5%" ><span>{{p.name}}</span></el-checkbox>
              </div>
              <div class="analyze-state-display" v-if="analyzeResult == 'loading' && simpleSubdomains.length == 0"
              >
                <svg t="1632819384962" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3046"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#8a8a8a" opacity=".3" p-id="3047"></path></svg>
              </div>
            </div>
          </div>
          <div style="position: absolute;bottom: 5px;right: 2px">
            <label style="color: #3a8ee6;text-decoration: underline;cursor: pointer" v-if="simpleSubdomains.length > 0" @click="chooseDomainItem">下一步></label>
          </div>
        </div>
<!--        复杂版-->
        <div class="new-question-body" v-show="getRequestType === 'question'">
          <div class="left-body">
            <div class="new-question-example" v-show="simpleSubdomains.length === 0">
                <div  class="new-question-example-item" v-for="(item, index) in exampleList" :key="index" @click="chooseExample(index)">
                  <label>{{item.label}}</label>
                </div>
            </div>

              <div class="simple-subdomains-container" v-show="simpleSubdomains.length !== 0">
                <div v-if="simpleSubdomains.length > 0" v-for="(p,index) in simpleSubdomains" :key="index" class="simpleSubdomiansDiv">
                  <div style="margin-right: 5px;position: absolute;right: 50.5%;display: flex;flex-direction: row">
                    <!--                  百分比柱状图显示-->
                    <label v-if="Math.floor(p.prob * 100) / 100 !== 0" style="margin-right: 5px">{{Math.floor(p.prob * 100).toString() + '%'}}</label>
                    <svg-bar type="rect" :value="100-Math.sqrt((p.prob))*100" :options="svgOptions" ></svg-bar>
                  </div>
                  <el-checkbox  @change="changeSubdomainItem(p.name)" v-if="p.check" :v-model="true" :checked="true" style="position: absolute;left: 50.5%"><span>{{p.name}}</span></el-checkbox>
                  <el-checkbox  @change="changeSubdomainItem(p.name)" v-else :v-model="false" :checked="false" style="position: absolute;left: 50.5%" ><span>{{p.name}}</span></el-checkbox>
                </div>
              </div>
            <div style="flex: 1;display: flex;flex-direction: column;height: 0;">
              <ul style="">
                <li v-for="(p,index) in domains" :key="index" style="display: inline;">
                  <label class="domainsLabel" v-if="currentTagIndex===p.id" v-on:click="setCurrent(p)" style="border-bottom-color: dodgerblue;color: dodgerblue;"> {{ p.name }} </label>
                  <label class="domainsLabel" v-else v-on:click="setCurrent(p)"> {{ p.name }} </label>
                </li>
              </ul>
              <draggable currentTagIndex.sync="currentTagIndex" v-model="domains[currentTagIndex].facts" :forceFallback="true" group="site"
                         animation="300" dragClass="dragClass"  ghost-class="ghostClass"
                         chosenClass="chosenClass" @start="onStart" @end="onEnd"
                         class="hideOver">
                <transition-group style="width: 40vw;display: inline-block;">
                  <div v-for="(item,index) in domains[currentTagIndex].facts" :key="index" class="item">
                    <el-tooltip effect="light" :content="item.text" placement="bottom">
                      <div style="display: flex;flex-direction: column;text-align: center;align-items: center;">
                        <img v-if="currentClickTag!==item.id" class="card" style="" v-bind:src="item.image"/>
                        <label v-if="currentClickTag!==item.id">{{item.sub_text}}</label>
                      </div>
                    </el-tooltip>
                  </div>
                </transition-group>
              </draggable>
              <p>除了AI分析以外您也可以手动拖动图标到右侧或在右侧点击图标进行取消</p>
            </div>
          </div>
          <div class="right-body">
            <div class="question-content-top">
              <textarea placeholder="输入您需要咨询的问题" v-model="questionData.prologue" style="padding:10px;border:1px solid lightgray;width:100%;height:20vh;color: #333; font-size: 16px;"></textarea>
              <div style="padding-left: 25px">
                <el-button style="margin-top: 5px;font-size: 16px;padding-top: 10px;padding-bottom: 10px" @click="getDomainsFunc">分析问题</el-button>
              </div>
            </div>
            <div style="width:80%;flex: 1;height: 0">
              <div class="fact-div">
<!--                拖拽组件-->
                <draggable v-model="selectedTags" filter=".forbid" disable="false" group="site"
                           animation="300" dragClass="dragClass" ghost-class="ghostClass"
                           chosenClass="chosenClass" @start="onStart" @end="onEnd" class="fact_drag"
                           style="background-image: url('./static/img/true.png');
                           background-position: center;background-repeat: no-repeat;background-size:auto 50%;">
                  <transition-group class="fact-container">
<!--                    <label style="white-space:nowrap" class="tag" v-for="(item, index) in selectedTags" :key="index" v-on:click="moveToArr1(item)">{{item.sub_text + ' ×'}}</label>-->
                    <div v-for="(item,index) in selectedTags" :key="index" class="item forbid" v-on:click="moveToArr1(item)" style="cursor: pointer">
                      <el-tooltip effect="light" :content="item.text" placement="bottom">
                        <div style="display: flex;flex-direction: column;text-align: center;align-items: center;">
                          <img v-if="currentClickTag!==item.id" class="card" v-bind:src="item.image"/>
                          <label v-if="currentClickTag!==item.id">{{item.sub_text}}</label>
                        </div>
                      </el-tooltip>
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <div class="fact-div">
                <draggable v-model="unSelectedTags" filter=".forbid" disable="false" group="site"
                           animation="300" dragClass="dragClass" ghost-class="ghostClass"
                           chosenClass="chosenClass" @start="onStart" @end="onEnd" class="fact_drag"
                           style="background-image: url('./static/img/false.png');
                           background-position: center;background-repeat: no-repeat;background-size:auto 50%">
                  <transition-group class="fact-container">
                      <div v-for="(item,index) in unSelectedTags" :key="index" class="item forbid" v-on:click="moveToArr1(item)" style="cursor: pointer">
                        <el-tooltip effect="light" :content="item.text" placement="bottom">
                          <div style="display: flex;flex-direction: column;text-align: center;align-items: center;">
                            <img v-if="currentClickTag!==item.id" class="card" v-bind:src="item.image"/>
                            <label v-if="currentClickTag!==item.id">{{item.sub_text}}</label>
                          </div>
                        </el-tooltip>
                      </div>
                  </transition-group>
                </draggable>
              </div>
            </div>
            <div style="padding-left: 10px;width: 80%;margin-top: 45px">
                <el-button :style="{marginTop: '5px',color:simpleSubdomains.length === 0?'#ccc' : 'deepskyblue',fontSize: '17px',paddingBottom:'10px',paddingTop: '10px'}"
                           :disabled="simpleSubdomains.length === 0"
                           v-if="getRequestType === 'question'" v-on:click="chooseDomainItem">开始咨询</el-button>
            </div>

          </div>
        </div>

<!--        <div class="question-body" v-show="getRequestType === 'domain'">-->
<!--          <div class="question-body-domain">-->
<!--            <div class="rebort-question">-->
<!--              <div class="rebort-question-left">-->
<!--                <img src="../../static/img/rebort.png" alt="">-->
<!--              </div>-->
<!--              <div class="rebort-question-right">-->
<!--                <p>根据您的描述，您是否想咨询以下问题？</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="rebort-response">-->
<!--              <div class="rebort-response-left">-->
<!--                <img src="../../static/img/znrebort.png" alt="">-->
<!--              </div>-->
<!--              <div class="rebort-response-right">-->
<!--                <el-radio-group v-model="questionData.subdomain" @change="loadAndGetTellsFunc" v-if="terminalsList.length > 0">-->
<!--                  <el-radio :label="item" v-for="item in terminalsList" :key="item">{{item}}</el-radio>-->
<!--                </el-radio-group>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div v-show="getRequestType === 'tells'" class="question-body">
          <div class="question-body-left" v-if="visionCommunicationEnabled">
            <div id="graph" style="width:100%; height:100%"></div>
          </div>
          <div class="question-body-right">
            <div class="rebort-question-wrap">
<!--              <div v-if="askQuestion.facet" style="display: flex;flex-direction: column;flex: 1;width: 100%">-->
              <div class="rebort-question-wrap-inner">
                <div class="rebort-chat-wrap">
                  <div class="rebort-header">
                    <div v-show="!beginGetTells"
                         style="position: relative"
                    >
                      <p style="width: 100%;height: 100%;text-align: center">法律机器人</p>
                      <div style="position: absolute;right: 20px;bottom: 1px">
                        <el-button @click="returnToSimpleMode" size="small" type="info" round>结束对话</el-button>
                      </div>
                    </div>
                    <div class="header-loading" v-show="beginGetTells">
                      <p>对方正在输入中&nbsp;</p>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div class="rebort-content"></div>
                </div>
                <div class="rebort-footer">
                  <el-radio-group v-model="questionData.tells" @change="chooseTellItem" v-show="showChooseBtn">
                    <el-radio :label="true" :disabled="beginGetTells">是</el-radio>
                    <el-radio :label="false" :disabled="beginGetTells">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="question-content-footer">
<!--          <label style="font-size: 14px;color: lightgrey">北京大学法律人工智能实验室 & 秘塔科技</label>-->
        </div>

      </div>
    </div>

    <!-- loading加载动画 -->
    <div class="loading-wrap" v-if="loading">
      <div class="loader">
        <div class="text">Loading...</div>
        <div class="horizontal">
          <div class="circlesup">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
          <div class="circlesdwn">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </div>
        <div class="vertical">
          <div class="circlesup">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
          <div class="circlesdwn">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 生成报告界面 -->
    <el-dialog title="" :visible.sync="reportVisible" width="70%" class="report-visible-wrap">
      <div class="">
        <h2>法律咨询报告</h2>
        <ul style="">
          <li v-for="(p,index) in report_map" :key="index" style="display: inline;text-align: center">
            <label class="domainsLabel" v-if="currentReport===p.id" v-on:click="setCurrentReport(p)" style="border-bottom-color: dodgerblue;color: dodgerblue;"> {{ p.subdomain }} </label>
            <label class="domainsLabel" v-else v-on:click="setCurrentReport(p)"> {{ p.subdomain }} </label>
          </li>
        </ul>
        <div  v-model="reportTxt" v-html="reportTxt"/>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

  </div>
</template>

<script>
import echarts from 'echarts'
import * as _ from 'lodash'
import { getDomains, getFactors, getGraph, getTells, createReport, getAsk, getSubdomain } from '@/api/api'
import draggable from 'vuedraggable'
import svg from 'svg-progress-bar'
// let echarts = require('echarts');
export default {
  name: 'question',
  components: {
    draggable,
    svg
  },
  data () {
    return {
      drag: false,
      currentTagIndex: 2,
      currentClickTag: -1,
      // 控制使用简略版还是复杂版
      getRequestType: 'simple',
      domainsList: [],
      terminalsList: [],
      chooseDomain: '',
      answer: [],
      currentQuestion: 0,
      report_map: {},
      currentReport: 0,
      simpleSubdomains: [],
      choosenSubdomains: [],
      questionData: {
        prologue: '你好，男的经常打骂我，我想离婚，现有一个三周半的女儿，我想争取到孩子。',
        domain: '',
        subdomain: '',
        yes: [],
        no: [],
        ask: 1,
        tells: null,
        subdomains: [],
        ask_queue: []
      },
      svgOptions: {
        radius: 13,
        duration: 0,
        pathColors: ['#409EFF', '#fff'],
        // rectRadius: 10,
        text: function (value) {
          return ''
        }

      },
      tells: {},
      exampleList: [
        {label: '收养案例', text: '我今年35岁，至今无子，想领养一个小孩，我可以吗？'},
        {label: '抚养案例', text: '我们已经结婚登记了，有一个孩子，我发现老公不做家务，我可以离婚吗？'},
        {label: '离婚案例', text: '你好，男的经常打骂我，我想离婚，现有一个三周半的女儿，我想争取到孩子。'},
        {label: '财产案例', text: '我想离婚，我要分财产，我还想要孩子抚养权，房子一起首付，我该怎么办？'}
      ],
      loading: false,
      beginGetTells: false,
      beginGetAsk: false,
      askQuestion: {},
      reportVisible: false,
      reportTxt: '就卡萨回复的开机登上发货单费会计师加水电费金卡戴珊发斯柯达交话费收款机还发萨克斯肯德基后方可手机号非单身看',
      askQuestionData: [],
      showChooseBtn: true,
      selectedTags: [],
      unSelectedTags: [],
      domains: [
        {
          id: 0,
          name: '收养问题',
          facts: [
            {id: 0, text: '收养人有配偶', sub_text: '有配偶', image: '../../static/img/shouyang/facts/1youpeiou.png'},
            {id: 1, text: '收养人有配偶且同意收养', sub_text: '配偶同意', image: '../../static/img/shouyang/facts/2peioutongyi.png'},
            {id: 2, text: '收养的是同性子女', sub_text: '同性子女', image: '../../static/img/shouyang/facts/3yixingzinv.png'},
            {id: 3, text: '收养人年满30周岁', sub_text: '满30', image: '../../static/img/shouyang/facts/4man30sui.png'},
            {id: 4, text: '收养的是异性子女且收养人和被收养人年龄相差40周岁以上', sub_text: '异性且相差40', image: '../../static/img/shouyang/facts/5xiangcha40sui.png'},
            {id: 7, text: '小孩是未成年人', sub_text: '未成年', image: '../../static/img/shouyang/facts/8chengnian.png'},
            {id: 10, text: '小孩是孤儿', sub_text: '孤儿', image: '../../static/img/shouyang/facts/11weichengnianguer.png'},
            {id: 14, text: '收养人是华侨', sub_text: '华侨', image: '../../static/img/shouyang/facts/15huaqiao.png'},
            {id: 16, text: '收养人有抚养、教育和保护被收养人的能力', sub_text: '抚、教、保能力', image: '../../static/img/shouyang/facts/17fujiaobaonengli.png'},
            {id: 17, text: '收养人未患有在医学上认为不应当收养子女的疾病', sub_text: '无疾病', image: '../../static/img/shouyang/facts/18wujibing.png'},
            {id: 18, text: '收养人无不利于被收养人健康成长的违法犯罪记录', sub_text: '无犯罪记录', image: '../../static/img/shouyang/facts/19wufanzuijilu.png'},
            {id: 19, text: '收养人和送养人均为自愿', sub_text: '收送人自愿', image: '../../static/img/shouyang/facts/20shousongrenziyuan.png'},
            {id: 20, text: '被收养人自愿', sub_text: '被收养自愿', image: '../../static/img/shouyang/facts/21beishouyangrenziyuan.png'},
            {id: 21, text: '被收养人不满8周岁', sub_text: '不满8岁', image: '../../static/img/shouyang/facts/22buman8sui.png'}
          ],
          subdomain: ['收养关系能否缔结', '收养人能否解除收养关系', '送养人能否要求解除收养关系', '被收养人能否解除收养关系']
        },
        {
          id: 1,
          name: '抚养权问题',
          facts: [
            {id: 100, text: '子女倾向男方', sub_text: '倾向男', image: '../../static/img/fuyangquan/1qingxiangnan.png'},
            {id: 101, text: '子女倾向女方', sub_text: '倾向女', image: '../../static/img/fuyangquan/2qingxiangnv.png'},
            {id: 102, text: '孩子的意愿没有倾向', sub_text: '无倾向', image: '../../static/img/fuyangquan/3wuqingxiang.png'},
            {id: 103, text: '男方有不适合抚养小孩的疾病', sub_text: '男疾病', image: '../../static/img/fuyangquan/4nanjibing.png'},
            {id: 104, text: '男方染上吸毒的恶习且屡教不改', sub_text: '男恶习', image: '../../static/img/fuyangquan/5nanexi.png'},
            {id: 105, text: '男方有家暴、虐待、遗弃小孩的行为', sub_text: '男家暴', image: '../../static/img/fuyangquan/6nanjiabao.png'},
            {id: 106, text: '女方有不适合抚养小孩的疾病', sub_text: '女疾病', image: '../../static/img/fuyangquan/7nvjibing.png'},
            {id: 107, text: '女方染上吸毒的恶习且屡教不改', sub_text: '女恶习', image: '../../static/img/fuyangquan/8nvexi.png'},
            {id: 108, text: '女方有家暴、虐待、遗弃小孩的行为', sub_text: '女家暴', image: '../../static/img/fuyangquan/9nvjiabao.png'},
            {id: 109, text: '在学校接受高中及以下学历教育', sub_text: '接受高中及以下教育', image: '../../static/img/fuyangquan/10jiaoyu.png'},
            {id: 110, text: '完全丧失劳动能力', sub_text: '完全丧失', image: '../../static/img/fuyangquan/11wanquansangshi.png'},
            {id: 111, text: '无独立生活能力', sub_text: '不能独立', image: '../../static/img/fuyangquan/12bunengduli.png'},
            {id: 112, text: '未完全丧失劳动能力', sub_text: '部分丧失', image: '../../static/img/fuyangquan/13bufensangshi.png'},
            {id: 113, text: '女方无固定收入', sub_text: '女无收入', image: '../../static/img/fuyangquan/14nvwushouru.png'},
            {id: 114, text: '男方无固定收入', sub_text: '男无收入', image: '../../static/img/fuyangquan/15nanwushouru.png'},
            {id: 115, text: '子女单独随姥姥姥爷共同生活多年', sub_text: '随姥姥姥爷', image: '../../static/img/fuyangquan/16laolao.png'},
            {id: 116, text: '子女单独随爷爷奶奶共同生活多年', sub_text: '随爷爷奶奶', image: '../../static/img/fuyangquan/17yeye.png'}
          ],
          subdomain: ['抚养权争夺']
        },
        {
          id: 2,
          name: '离婚问题',
          facts: [
            {id: 200, text: '无子女', sub_text: '无子女', image: '../../static/img/lihun/facts/1wuzinv.png'},
            {id: 201, text: '无房产', sub_text: '无房产', image: '../../static/img/lihun/facts/2wufangchan.png'},
            {id: 202, text: '未办理结婚登记手续', sub_text: '未登记', image: '../../static/img/lihun/facts/3weidengji.png'},
            {id: 203, text: '男方实施家庭暴力', sub_text: '男实施家暴', image: '../../static/img/lihun/facts/4nanjiaobao.png'},
            {id: 204, text: '男方赌博、吸毒、酗酒等不良嗜好', sub_text: '男不良嗜好', image: '../../static/img/lihun/facts/5nanbuliangshihao.png'},
            {id: 205, text: '女方赌博、吸毒、酗酒等不良嗜好', sub_text: '女不良嗜好', image: '../../static/img/lihun/facts/6nvbuliangshihao.png'},
            {id: 206, text: '女方怀孕', sub_text: '怀孕', image: '../../static/img/lihun/facts/7pregnant.png'},
            {id: 207, text: '重婚', sub_text: '重婚', image: '../../static/img/lihun/facts/8chonghun.png'},
            {id: 208, text: '双方达到法定婚龄', sub_text: '法定婚龄', image: '../../static/img/lihun/facts/9fadinghunling.png'},
            {id: 209, text: '双方就离婚事宜协商一致', sub_text: '协议离婚', image: '../../static/img/lihun/facts/10xieyilihun.png'}
          ],
          subdomain: ['双方婚姻效力', '男方请求离婚', '女方请求离婚']
        },
        {
          id: 3,
          name: '离婚财产问题',
          facts: [
            {id: 300, text: '未办理结婚登记手续', sub_text: '未登记', image: '../../static/img/lihuncaichan/facts/1hunyindengji.png'},
            {id: 301, text: '产权证上登记了除男女当事人之外的其他人', sub_text: '登记其他人', image: '../../static/img/lihuncaichan/facts/2dengjiqitareng.png'},
            {id: 302, text: '房屋尚未取得房屋所有权证', sub_text: '产权证', image: '../../static/img/lihuncaichan/facts/3chanquanzheng.png'},
            {id: 303, text: '房屋登记在男方名下', sub_text: '男方名字', image: '../../static/img/lihuncaichan/facts/4nanfangmingzi.png'},
            {id: 304, text: '房屋登记在女方名下', sub_text: '女方名字', image: '../../static/img/lihuncaichan/facts/5nvfangmingzi.png'},
            {id: 305, text: '房屋登记在夫妻双方名下', sub_text: '双方名字', image: '../../static/img/lihuncaichan/facts/6shaungfangmingzi.png'},
            {id: 306, text: '房子是继承过来的', sub_text: '继承', image: '../../static/img/lihuncaichan/facts/7jicheng.png'},
            {id: 307, text: '房子是亲友赠送的', sub_text: '赠送', image: '../../static/img/lihuncaichan/facts/8zengsong.png'},
            {id: 308, text: '房子是婚前购买的', sub_text: '婚前全款购买', image: '../../static/img/lihuncaichan/facts/9hunqianquankuangoumai.png'},
            {id: 309, text: '房屋是婚后购买', sub_text: '婚后购买', image: '../../static/img/lihuncaichan/facts/10hunhougoumai.png'},
            {id: 310, text: '房子是婚前首付婚后贷款购买的', sub_text: '婚前首付婚后贷款', image: '../../static/img/lihuncaichan/facts/11hunqianshoufuhunhoudaikuan.png'},
            {id: 311, text: '房子的购买男方有出资', sub_text: '男方出资', image: '../../static/img/lihuncaichan/facts/12nanfangchuzi.png'},
            {id: 312, text: '房子的购买男方家人有出资', sub_text: '男方家人出资', image: '../../static/img/lihuncaichan/facts/13nanfangjiarengchuzi.png'},
            {id: 313, text: '房子的购买女方有出资', sub_text: '女方出资', image: '../../static/img/lihuncaichan/facts/14nvfangchuzi.png'},
            {id: 314, text: '房子的购买女方家人有出资', sub_text: '女方家人出资', image: '../../static/img/lihuncaichan/facts/15nvfangjiarengchuzi.png'},
            {id: 315, text: '结婚后男方没有和女方一起共同生活', sub_text: '未共同生活', image: '../../static/img/lihuncaichan/facts/16weigongtongjuzhu.png'},
            {id: 316, text: '给付彩礼导致男方生活困难', sub_text: '彩礼致贫', image: '../../static/img/lihuncaichan/facts/17cailizhiping.png'}
          ],
          subdomain: ['房产分割', '彩礼返还']
        }
      ],
      domainPriority: {
        双方婚姻效力: 0,
        女方请求离婚: 1,
        男方请求离婚: 2,
        彩礼返还: 3,
        房产分割: 4,
        其他财产: 5,
        收养关系能否缔结: 6,
        送养人能否要求解除收养关系: 7,
        收养人能否解除收养关系: 8,
        被收养人能否解除收养关系: 9,
        抚养权争夺: 10
      },
      analyzeResult: 'notRequestYet', // 其他值'analyzing' 'done' 'errorOccur'
      visionCommunicationEnabled: false
    }
  },
  created () {

  },
  mounted () {
    var isChrome = window.navigator.userAgent.indexOf('Chrome') > -1
    if (!isChrome) {
      this.$notify({
        title: '请使用Chrome内核浏览器',
        message: '为保证页面功能正常,请使用Chrome浏览器、搜狗浏览器、360急速浏览器等Chrome内核的浏览器',
        duration: 5000
      })
    }
  },

  methods: {
    returnToSimpleMode () {
      this.getRequestType = 'simple'
      this.simpleSubdomains = []
      this.choosenSubdomains = []
      this.beginGetTells = false
      this.beginGetAsk = false
      this.askQuestion = {}
      this.questionData = {
        prologue: '你好，男的经常打骂我，我想离婚，现有一个三周半的女儿，我想争取到孩子。',
        domain: '',
        subdomain: '',
        yes: [],
        no: [],
        ask: 1,
        tells: null,
        subdomains: [],
        ask_queue: []
      }
      this.tells = null
      $('.rebort-content')[0].innerHTML = ''
    },
    reloadPage: function () {
      location.reload()
    },
    getSubdomainFunc: function () {
      // this.questionData.simpleSubdomains = ["男方请求离婚", "房产分割"]
      // return ;
      let _this = this
      let params = {
        prologue: this.questionData.prologue
      }
      this.simpleSubdomains = []
      getSubdomain(params).then(res => {
        if (res.data.code === 0) {
          let temp = []
          for (let i = 0; i < res.data.subdomains.length; i++) {
            if (res.data.subdomains[i]['check'] === true) {
              temp.push(res.data.subdomains[i]['name'])
            }
          }
          this.simpleSubdomains.splice(0, this.simpleSubdomains.length, ...res.data.subdomains)
          // this.choosenSubdomains.splice(0, this.choosenSubdomains.length, ...temp)
        }
        this.analyzeResult = 'done'
      })
      console.log(_this.simpleSubdomains)
    },
    getDomainsFunc: function () {
      let _this = this
      let params = {
        prologue: this.questionData.prologue
      }
      this.analyzeResult = 'loading'
      getDomains(params).then(res => {
        if (res.data.code === 0) {
          if (res.data.domains !== undefined && res.data.domains.length !== 0) {
            this.questionData.domain = res.data.domains[0]
            if (res.data.domains[0].subdomains !== undefined && res.data.domains[0].subdomains.length > 0) {
              _this.questionData.subdomains = res.data.domains[0].subdomains
            }
            this.getFactorsFunc()
            this.getSubdomainFunc()
          } else {

          }
        } else {
          console.log('获取类别列表失败', res)
          this.analyzeResult = 'errorOccur'
        }
      }).catch(res => {
        console.log('获取类别列表失败', res)
        this.analyzeResult = 'errorOccur'
      })
    },
    getFactorsFunc: function () {
      // this.loading = true
      let _this = this
      let params = {
        prologue: this.questionData.prologue,
        domain: this.questionData.domain.name
      }
      let map = {}, unMap = {}
      for (let i = 0; i < _this.selectedTags.length; i++) {
        map[_this.selectedTags[i].text] = _this.selectedTags[i]
        unMap[_this.selectedTags[i].text] = _this.selectedTags[i]
      }
      for (let i = 0; i < _this.unSelectedTags.length; i++) {
        map[_this.unSelectedTags[i].text] = _this.unSelectedTags[i]
        unMap[_this.unSelectedTags[i].text] = _this.unSelectedTags[i]
      }
      getFactors(params).then(res => {
        if (res.data.code === 0) {
          _.forEach(res.data.factors, (p, index) => {
            let obj = {
              id: 1000 + index,
              text: p.name,
              sub_text: '',
              image: ''
            }
            for (let i = 0; i < this.domains.length; i++) {
              let t = this.domains[i]
              for (let j = 0; j < t.facts.length; j++) {
                if (t.facts[j].text === obj.text) {
                  obj.sub_text = t.facts[j].sub_text
                  obj.image = t.facts[j].image
                }
              }
            }
            if (p.value === 'true') {
              _this.questionData.yes.push(p.name)
              if (!map.hasOwnProperty(obj.text)) {
                _this.selectedTags.push(obj)
                map[obj.text] = obj
              }
            } else if (p.value === 'false') {
              _this.questionData.no.push(p.name)
              if (!unMap.hasOwnProperty(obj.text)) {
                _this.unSelectedTags.push(obj)
                unMap[obj.text] = obj
              }
            }
          })
          console.log(_this.selectedTags)
          // this.getTellsFunc()
        } else {
          console.log('获取要素失败', res)
        }
      }).catch(res => {
        console.log('获取要素失败', res)
      })
    },
    chooseExample: function (index) {
      this.currentTagIndex = index
      this.questionData.prologue = this.exampleList[index].text
    },
    chooseDomainItem: function () {
      // if (this.questionData.domain.subdomains && this.questionData.domain.subdomains.length > 0) {
      //   this.terminalsList = this.questionData.domain.subdomains
      // } else {
      //   this.loading = true
      //   this.getFactorsFunc()
      // }
      this.questionData.yes = []
      for (let i = 0; i < this.selectedTags.length; i++) {
        this.questionData.yes.push(this.selectedTags[i].text)
      }
      this.questionData.no = []
      for (let i = 0; i < this.unSelectedTags.length; i++) {
        this.questionData.no.push(this.unSelectedTags[i].text)
      }
      for (let i = 0; i < this.simpleSubdomains.length; i++) {
        if (this.simpleSubdomains[i].check) {
          this.choosenSubdomains.push(this.simpleSubdomains[i].name)
        }
      }
      let obj = {
        name: this.domains[this.currentTagIndex].name,
        subdomains: this.choosenSubdomains
      }
      this.questionData.ask_queue = []
      for (let i = 0; i < this.choosenSubdomains.length; i++) {
        let t = {
          name: this.choosenSubdomains[i],
          step: 'wait'
        }
        this.questionData.ask_queue.push(t)
      }
      this.questionData.ask_queue = this.questionData.ask_queue.sort((a, b) => {
        const aPriortyNum = this.domainPriority[a.name]
        const bPriortyNum = this.domainPriority[b.name]

        return aPriortyNum - bPriortyNum
      })
      console.log('sorted',this.questionData.ask_queue)
      this.questionData.domain = obj
      this.questionData.subdomain = this.questionData.domain.subdomains[0]
      this.questionData.subdomains = this.choosenSubdomains
      this.questionData.ask_queue[0].step = 'start'
      this.getRequestType = 'tells'
      this.loading = true
      this.currentQuestion = 0
      this.getTellsFunc(true)
    },
    chooseTellItem: function () {
      let _this = this
      if (this.tells.facts) {
        if (this.tells.facts.yes) {
          _.forEach(this.tells.facts.yes, (o) => {
            _this.questionData.yes.push(o.name)
          })
        }
        if (this.tells.facts.no) {
          _.forEach(this.tells.facts.no, (p) => {
            _this.questionData.no.push(p.name)
          })
        }
      }
      let awn = this.questionData.tells ? '是' : '否'
      let awsHtml = ''
      awsHtml += '<div class="rebort-content-user">'
      awsHtml += '<div class="rebort-content-owner-text">'
      awsHtml += '<pre>' + awn + '</pre></div>'
      awsHtml += '<img src="../../static/img/znrebort.png" alt=""/>'
      awsHtml += '</div>'
      this.$nextTick(() => {
        $('.rebort-content').append(awsHtml)
        $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight + 200)
        setTimeout(function () { $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight + 200) }, 500)
      })
      this.getTellsFunc(true)
    },
    loadAndGetTellsFunc: function () {
      this.loading = true
      this.getTellsFunc(true)
    },
    getTellsFunc: function (needAdd) {
      let _this = this
      this.getRequestType = 'tells'
      this.beginGetTells = true
      if (needAdd) {
        if (this.askQuestion.name) {
          if (this.questionData.tells) {
            this.questionData.yes.push(this.askQuestion.name)
          } else {
            this.questionData.no.push(this.askQuestion.name)
          }
        }
      }

      let params = {
        prologue: this.questionData.prologue,
        // domain: this.questionData.domain.name,
        subdomains: this.questionData.ask_queue,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no)),
        ans: this.askQuestion.name
      }
      getTells(params).then(res => {
        if (res.data.code === 0) {
          this.questionData.tells = null
          if (res.data.tell.facts) {
            if (res.data.tell.facts.yes) {
              _.forEach(res.data.tell.facts.yes, (o) => {
                _this.questionData.yes.push(o.name)
              })
            }
            if (res.data.tell.facts.no) {
              _.forEach(res.data.tell.facts.no, (p) => {
                _this.questionData.no.push(p.name)
              })
            }
          }
          console.log(res.data)
          _this.loading = false
          this.tells = res.data.tell
          if (res.data.tell.response) {
            let html = ''
            html += '<div class="rebort-content-owner">'
            html += '<img src="../../static/img/rebort.png" alt="">'
            html += '<div class="rebort-content-owner-text">'
            html += '<pre>' + res.data.tell.response + '</pre>'
            html += '</div></div>'
            $('.rebort-content').append(html)
            setTimeout(function () {
              $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight)
            }, 500)
          }
          this.getGraphFunc()
          console.log(res.data)
          if (res.data.tell.terminate && this.currentQuestion === this.questionData.ask_queue.length - 1) {
            setTimeout(function () {
              _this.tells = res.data.tell
              _this.loading = false
              _this.beginGetTells = false
              _this.beginGetAsk = false
              _this.showChooseBtn = false
              let lastHtml = ''
              lastHtml += '<div class="rebort-content-owner">'
              lastHtml += '<img src="../../static/img/rebort.png" alt="">'
              lastHtml += '<div class="rebort-content-owner-text">'
              lastHtml += '<pre><a id="retunrToHome">返回首页</a><a id="viewReport">查看报告</a></pre>'
              lastHtml += '</div></div>'
              $('.rebort-content').append(lastHtml)
              $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight)
              $('#retunrToHome').on('click', function () {
                _this.reloadPage()
              })
              $('#viewReport').on('click', function () {
                _this.submitReport(true)
              })
            }, 3000)
          } else if (res.data.tell.terminate) {
            this.questionData.ask_queue[this.currentQuestion].step = 'end'
            _this.submitReport(false)
          } else {
            this.questionData.ask_queue[this.currentQuestion].step = 'middle'
            // _this.submitReport(false)
            _this.getAskFuc()
          }
        } else {
          this.getGraphFunc()
          console.log('获取后续问题失败', res.msg)
        }
        // this.loading = false
      }).catch(res => {
        console.log('获取后续问题失败', res)
      })
    },
    getAskFuc: function () {
      this.beginGetAsk = true
      // if (this.tells.question) {
      //   if (this.questionData.tells) {
      //     this.questionData.yes.push(this.tells.question.name)
      //   } else {
      //     this.questionData.no.push(this.tells.question.name)
      //   }
      // }
      let params = {
        prologue: this.questionData.prologue,
        // domain: this.questionData.domain.name,
        subdomain: this.questionData.ask_queue[this.currentQuestion].name,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no))
      }
      console.log('getAskFuc ,params', params)

      getAsk(params).then(res => {
        this.loading = false
        this.beginGetTells = false
        this.beginGetAsk = false
        this.answer = res.data.question.facet
        if (res.data.code === 0) {
          this.askQuestion = res.data.question
          let askHtml = ''
          askHtml += '<div class="rebort-content-owner">'
          askHtml += '<img src="../../static/img/rebort.png" alt="">'
          askHtml += '<div class="rebort-content-owner-text">'
          askHtml += '<pre style="align-items: center;position: relative;horiz-align: center">' + res.data.question.facet + '</pre>'
          askHtml += '</div></div>'
          this.$nextTick(() => {
            $('.rebort-content').append(askHtml)
            $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight + 200)
            setTimeout(function () { $('.rebort-content').scrollTop($('.rebort-content')[0].scrollHeight + 200) }, 500)
          })
        } else {
          console.log('获取后续问题失败', res.msg)
        }
      }).catch(res => {
        console.log('获取后续问题失败', res)
      })
    },
    getGraphFunc: function () {
      let _this = this
      let params = {
        // prologue: this.questionData.prologue,
        // domain: this.questionData.domain.name,
        subdomains: this.choosenSubdomains,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no)),
        gexf: 1
      }
      getGraph(params).then(res => {
        this.initEcharts(res.data)
      }).catch(res => {
        console.log('获取关系图失败', res)
      })
    },
    initEcharts: function (xml) {
      let myChart = echarts.init(document.getElementById('graph')), option
      echarts.dataTool = require('echarts/extension/dataTool')
      let graph = echarts.dataTool.gexf.parse(xml)
      var categories = []
      for (var i = 0; i < 9; i++) {
        categories[i] = {
          name: '类目' + i
        }
      }
      graph.nodes.forEach(function (node) {
        node.value = node.symbolSize
        if (node.name.indexOf('非 ') !== -1) {
          node.itemStyle.normal.color = '#2f4553'
        }
        node.ftype = node.attributes.ftype
        if (node.ftype === 'askable') {
          // node.itemStyle.normal.color = '#639fa7'
        } else if (node.ftype === 'terminal') {
          if (node.name.indexOf('非 ') !== -1) {
            node.itemStyle.normal.color = '#2f4553'
          } else {
            node.itemStyle.normal.color = '#c8842f'
          }
          node.symbolSize = 64
        } else if (node.ftype === 'extractable') {
          node.itemStyle.normal.borderWidth = 4
          node.itemStyle.normal.borderColor = '#409EFF'
        } else if (node.ftype === 'internal') {

        }
        node.symbolSize /= 1.5
        node.rule = node.attributes.rule
        node.label = {
          show: true,
          fontSize: 14
        }
        node.category = node.attributes.modularity_class
      })
      option = {
        title: {
          text: '',
          subtext: '',
          top: 'bottom',
          left: 'right'
        },
        tooltip: {
          formatter: function (params, ticket, callback) {
            var rule = ''
            if (params.data.attributes && params.data.attributes.rule) {
              rule = params.data.attributes.rule
              var nameTitle = rule.substr(0, rule.indexOf(' '))
              rule = rule.replace(nameTitle, '<span style="color: #E6A23C; font-weight: 700; font-size: 16px;">' + nameTitle + '</span>')
              rule = rule.replace(/ 且/g, '<span style="color: cyan;"> 且</span>')
              rule = rule.replace(/ 或/g, '<span style="color: cyan;"> 或</span>')
              rule = rule.replace(/非 /g, '<span style="color: cyan;">非 </span>')
              rule = rule.replace(/\\n/g, '<br/>')
            } else {
              rule = ''
            }
            return rule
          },
          position: 'top',
          distance: 20,
          backgroundColor: 'rgba(0, 0, 0, .6)',
          textStyle: {
            color: '#fff',
            fontSize: 14,
            align: 'left'
          }
        },
        // legend: [{
        //   data: categories.map(function(a) {
        //     return a.name
        //   })
        // }],
        animationDuration: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [{
          name: '',
          type: 'graph',
          layout: 'force',
          data: graph.nodes,
          links: graph.links,
          categories: categories,
          roam: true,
          focusNodeAdjacency: true,
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [0, 10],
          symbol: 'circle',
          itemStyle: {
            normal: {
              borderColor: '#fff',
              borderWidth: 1,
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
          },
          label: {
            position: 'right',
            formatter: '{b}'
          },
          lineStyle: {
            color: 'source',
            curveness: 0.3,
            width: 3
          },
          emphasis: {
            lineStyle: {
              width: 5
            }
          },
          force: {
            repulsion: 300,
            layoutAnimation: true
          }
        }]
      }
      myChart.setOption(option)
    },
    submitReport: function (end) {
      let params = {
        // domain: this.questionData.domain.name,
        subdomain: this.questionData.ask_queue[this.currentQuestion].name,
        yes: Array.from(new Set(this.questionData.yes)),
        no: Array.from(new Set(this.questionData.no))
      }
      createReport(params).then(res => {
        if (res.data.code === 0) {
          // var oDiv=document.createElement("DIV");
          // this.reportTxt = res.data.report
          // this.reportVisible = true
          this.report_map[this.currentQuestion] = {
            text: res.data.report,
            subdomain: params.subdomain,
            id: this.currentQuestion
          }

          if (end) {
            console.log(this.report_map)
            this.currentReport = 0
            this.reportTxt = this.report_map[0].text
            this.reportVisible = true
          } else {
            this.currentQuestion++
            this.questionData.ask_queue[this.currentQuestion].step = 'start'
            this.getTellsFunc(false)
          }
          // oDiv.innerHTML=res.data.report;
          // console.log(oDiv)
          // document.getElementById("report").appendChild(oDiv);
        } else {
          this.$message({
            type: 'error',
            message: '生成报告失败'
          })
        }
      }).catch(res => {
        console.log(res)
        this.$message({
          type: 'error',
          message: '生成报告失败'
        })
      })
    },
    // 开始拖拽事件
    onStart () {
      // this.drag=true;
    },
    // 拖拽结束事件
    onEnd () {
      this.drag = false
      let list = {}
      console.log(this.selectedTags)
      for (let i = 0; i < this.selectedTags.length; i++) {
        if (!list.hasOwnProperty(this.selectedTags[i].text)) {
          list[this.selectedTags[i].text] = this.selectedTags[i]
        } else {
          this.$toast('该标签已存在')
          list[this.selectedTags[i].text].id < this.selectedTags[i].id
            ? this.moveToArr1(list[this.selectedTags[i].text]) : this.moveToArr1(this.selectedTags[i])
        }
      }
      for (let i = 0; i < this.unSelectedTags.length; i++) {
        if (!list.hasOwnProperty(this.unSelectedTags[i].text)) {
          list[this.unSelectedTags[i].text] = this.unSelectedTags[i]
        } else {
          this.$toast('该标签已存在')
          list[this.unSelectedTags[i].text].id < this.unSelectedTags[i].id
            ? this.moveToArr1(list[this.unSelectedTags[i].text]) : this.moveToArr1(this.unSelectedTags[i])
        }
      }
    },
    moveToArr1 (item) {
      let _this = this
      console.log(this.selectedTags)
      console.log(this.unSelectedTags)
      for (let i = 0; i < _this.selectedTags.length; i++) {
        if (_this.selectedTags[i] === item) {
          _this.selectedTags.splice(i, 1)
          break
        }
      }
      for (let i = 0; i < _this.unSelectedTags.length; i++) {
        if (_this.unSelectedTags[i] === item) {
          _this.unSelectedTags.splice(i, 1)
          break
        }
      }
      _this.domains[Math.floor(item.id / 100)].facts.push(item)
      _this.domains[Math.floor(item.id / 100)].facts.sort(function (a, b) {
        return a.id - b.id
      })
    },
    setCurrent: function (p) {
      this.currentTagIndex = p.id
    },
    inChoosenSubdomain: function (item) {
      return this.choosenSubdomains.indexOf(item) !== -1
    },
    changeSubdomainItem: function (item) {
      for (let i = 0; i < this.simpleSubdomains.length; i++) {
        let ob = this.simpleSubdomains[i]
        if (ob.name === item) {
          this.simpleSubdomains[i].check = !this.simpleSubdomains[i].check
        }
      }
    },
    changeModel: function () {
      this.questionData = {
        prologue: '你好，男的经常打骂我，我想离婚，现有一个三周半的女儿，我想争取到孩子。',
        domain: '',
        subdomain: '',
        yes: [],
        no: [],
        ask: 1,
        tells: null
      }
      this.simpleSubdomains = []
      this.choosenSubdomains = []
      if (this.getRequestType === 'simple') {
        this.getRequestType = 'question'
      } else if (this.getRequestType === 'question') {
        this.getRequestType = 'simple'
      }
    },
    setCurrentReport: function (p) {
      this.currentReport = p.id
      this.reportTxt = p.text
    }
  }

}
</script>

<style lang="less">
  .question-wrap {
    background-image: url(../../static/img/back.jpg);
    background-repeat: repeat;
    background-size: 100% 100%;
    min-width: 100vw;
    min-height: 100vh;
    width: 100vw;
    height: 100vh;
    position: relative;
    color: #333;
    .question-content {
      flex-direction: column;
      display: flex;
      background: #fff;
      width: 93vw;
      min-height: 85vh;
      height: 85vh;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      vertical-align: middle;
      padding: 15px;
      .simple-question-body{
        display: flex;
        position: relative;
        flex-direction: column;
        flex: 1;
        align-items: center;
        .question-content-top {
          width: 40%;
          margin-bottom: 10px;
          align-items: center;
          .el-textarea {
            textarea {
              font-size: 16px;
              color: #333;
            }
          }
          .el-button--primary {
            display: block;
            padding: 9px 25px;
            margin: 10px auto 0;
            font-size: 16px;
          }
        }
        .simple-subdomains-container{
          //display: flex;
          //float: left;
          width: 80%;
          height: 100%;
          //flex: 1;
          //horiz-align: center;
          display: flex;
          flex-direction: column;
          flex: 1;
          //horiz-align: center;
          //float: left;
          justify-content: center;
          margin: auto;
          .simpleSubdomiansDiv{
            display: flex;
            flex-direction: row;
            width: 50%;
            height: 3vh;
            text-align: left;
            float: left
          }

        }
      }
      .new-question-body{
        display: flex;
        position: relative;
        flex-direction: row;
        flex: 1;
        .left-body {
          display: flex;
          flex-direction: column;
          width: 40vw;
          position: relative;
          .simple-subdomains-container{
            flex: 1;
            horiz-align: center;
            display: flex;
            flex-direction: column;
            .simpleSubdomiansDiv{
              display: flex;
              flex-direction: row;
              width: 50%;
              height: 3vh;
              text-align: left;
              float: left
            }
            .simpleSubdomains{
              display: flex;
              width: 15vw;
              flex-direction: column;
              text-align: left;
              float: left;
              height: 15vh;
              margin-left: 5vw;
            }
          }
          .new-question-example {
            height: 20vh;
            flex-direction: row;
            width: 100%;
            display: inline-block;
            margin-bottom: 42px;
            .new-question-example-item {
              width: 25%;
              padding: 10px;
              border-width: 1px;
              border-color: lightgray;
              border-radius: 7px;
              border-style: solid;
              display: inline-block;
              margin-bottom: 10%;
              margin-right: 10%;
              margin-left: 5%;
            }
            .chosen-example-item {
              background-color: dodgerblue;
              color: white;
            }
          }
        }
        .right-body {
          width: 50vw;
          margin-left: 30px;
          flex-direction: column;
          display: flex;
          position: relative;
        }
      }
      .next-step{
        float: right;
        right: 5%;
        text-decoration:underline;
        color: blue;
        margin-top: 10px;
        cursor: pointer;
      }
      .fact-container{
        height: 90%;
        width: 100%;
        display: inline-block;
      }
      .fact_drag{
        overflow: hidden visible;
        height: 100%;
      }
      .fact_drag::-webkit-scrollbar{
        width: 0;
        /* display: none; */
        height: 0;
      }
      .fact-div{
        //flex: 1;
        flex-direction: column;
        display: flex;
        height: 50%;
        width: 100%;
        border-color: lightgray;
        border-width: 1px;
        border-style: solid;
        padding: 10px;
      }
      .fact-div + .fact-div{
        border-top-width: 0;
      }
      .question-container {
        flex-direction: column;
        position: relative;
        height: 100%;
        display: flex;
        box-sizing: border-box;
        padding: 94px 0 34px 0;
        .question-title {
          //margin-bottom: 40px;
          position: relative;
          font-size: 40px;
          height: 54px;
          margin:-94px 0 40px 0;
          span {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 14px;
            font-weight: normal;
          }
        }
        .question-body {
          display: flex;
          position: relative;
          flex-direction: row;
          //flex: 1;
          height: 100%;
          .question-body-left {
            //flex: 1;
            display: flex;
            width: 50%;
            height: 100%;
            margin-right: 15px;
            .question-body-left-wrap {
              width: 100%;
              align-items: center;
            }
            h3 {
              color: #6e6e6e;
              margin-bottom: 15px;
            }
          }
          .question-body-right {
            //flex: 1;
            width: 50%;
            height: 100%;
            &:last-child:first-child{
              margin: 0 auto;
            }
          }
          .question-body-bottom {
            top: 50px;
            position: relative;
          }
          .question-body-left-bottom {
            width: 500px;
          }
          h4 {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -65%);
          }
        }
        .question-content-top {
          width: 80%;
          //margin: 0 auto;
          //position: absolute;
          //top: 50%;
          //left: 50%;
          //transform: translate(-60%, -45%);
          margin-bottom: 10px;
          .el-textarea {
            textarea {
              font-size: 16px;
              color: #333;
            }
          }
          .el-button--primary {
            display: block;
            padding: 9px 25px;
            margin: 10px auto 0;
            font-size: 16px;
          }
        }
        .question-example-wrap {
          overflow: hidden;
          text-align: center;
          background-color: white;
          margin-bottom: 30px;
          .question-example-item {
            background-image: url(../../static/img/ex01.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 0;
            width: 150px;
            height: 25vh;
            display: inline-block;
            margin-top: 25px;
            cursor: pointer;
            position: relative;
            vertical-align: middle;
            p {
              position: absolute;
              top: 50%;
              padding: 0 12px;
              font-size: 14px;
              left: 0;
              right: 0;
              transform: translateY(-28%);
              line-height: 22px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
            }
            &:nth-child(2) {
              background-image: url(../../static/img/ex02.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: 0;
              width: 180px;
              height: 26vh;
              margin: 0 5%;
              p {
                color: #fff;
                font-size: 15px;
              }
            }
          }
        }
        .question-body-domain {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .rebort-question-wrap {
          //position: absolute;
          //top: 50%;
          //left: 50%;
          width: 100%;
          height: 90%;

          //display: flex;
          //flex-direction: column;
          //transform: translate(-50%, -50%);
          box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
          .rebort-question-wrap-inner{
            padding-bottom: 70px;
            box-sizing: border-box;
            //display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
          }
          .rebort-footer {
            padding: 25px 0;
            border-top: 1px solid #ddd;
          }
          .rebort-chat-wrap {
            //display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            background: #f3f3f3;
            box-sizing: border-box;
            padding-top: 45px;
            .rebort-header {
              height: 45px;
              margin-top: -45px;
              line-height: 45px;
              color: #fff;
              background: #3c3c3c;
              .header-loading {
                margin: 0 auto;
                p {
                  display: inline-block;
                }
                span{
                  display: inline-block;
                  width: 5px;
                  height: 5px;
                  margin-right: 5px;
                  border-radius: 50%;
                  background: #fff;
                  -webkit-animation: load 1.04s ease infinite;
                  vertical-align: middle;
                }
                span:last-child{
                  margin-right: 0px;
                }
                @-webkit-keyframes load{
                  0%{
                    opacity: 1;
                  }
                  100%{
                    opacity: 0;
                  }
                }
                span:nth-child(1){
                  -webkit-animation-delay:0.13s;
                }
                span:nth-child(2){
                  -webkit-animation-delay:0.26s;
                }
                span:nth-child(3){
                  -webkit-animation-delay:0.39s;
                }
                .span:nth-child(4){
                  -webkit-animation-delay:0.52s;
                }
                span:nth-child(5){
                  -webkit-animation-delay:0.65s;
                }
              }
            }
            .rebort-content {
              padding: 0 10px;
              height: 100%;
              //flex: 1;
              overflow: hidden auto;
            }
            .el-radio__label {
              font-size: 16px;
            }

          }
          .rebort-content-owner {
            text-align: left;
            margin-top: 15px;
            position: relative;
            min-height: 50px;
            img {
              width: 42px;
              height: 42px;
              display: inline-block;
              background: #E6A23C;
              border-radius: 50%;
              position: absolute;
              top: 0;
              left: 0;
            }
            .rebort-content-owner-text {
              display: inline-block;
              font-size: 14px;
              margin-left: 60px;
              box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
              padding: 10px;
              background: #fff;
              position: relative;
              border-radius: 4px;
              max-width: 250px;
              margin-bottom: 10px;
              align-items: center;
              pre {
                white-space: pre-wrap;
                a {
                  color: #4739bc;
                  display: inline-block;
                  text-decoration: underline;
                  cursor: pointer;
                  &:first-child {
                    margin-right: 10px;
                  }
                }
                img{
                  position: relative;
                  width: 120px;
                  height: auto;
                  border-radius: 0;
                }
              }
            }
            .rebort-content-owner-text::before {
              content: '';
              display: block;
              position: absolute;
              width: 0;
              height: 0;
              border-top: 8px solid transparent;
              border-right: 13px solid #fff;
              border-bottom: 8px solid transparent;
              left: -10px;
              top: 11px;
            }
          }
          .rebort-content-user {
            text-align: right;
            margin-top: 15px;
            position: relative;
            min-height: 50px;
            img {
              width: 42px;
              height: 42px;
              display: inline-block;
              background: #409EFF;
              border-radius: 50%;
              position: absolute;
              top: 0;
              right: 0;
              float: right;
            }
            .rebort-content-owner-text {
              text-align: left;
              display: inline-block;
              font-size: 14px;
              margin-right: 60px;
              box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
              padding: 10px;
              background: #fff;
              position: relative;
              border-radius: 4px;
              margin-top: 3px;
            }
            .rebort-content-owner-text::before {
              content: '';
              display: block;
              position: absolute;
              width: 0;
              height: 0;
              border-top: 8px solid transparent;
              border-left: 13px solid #fff;
              border-bottom: 8px solid transparent;
              right: -10px;
              top: 11px;
            }
          }
        }
        .rebort-question {
          overflow: hidden;
          padding: 5px;
          margin-bottom: 20px;
          .rebort-question-left {
            display: inline-block;
            background: #E6A23C;
            float: left;
            padding: 5px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 35px;
            img {
              width: 30px;
              height: 30px;
              vertical-align: middle;
              display: inline-block;
            }
          }
          .rebort-question-right {
            margin-left: 70px;
            text-align: left;
            box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
            border-radius: 4px;
            background: #fff;
            padding: 10px 15px;
            pre {
              white-space: pre-wrap;
              font-size: 16px;
            }
            .rebort-question-right-wrap {
              max-height: 25px;
              overflow: hidden;
              .rebort-question-list {
                animation: moveTop 8s infinite linear;
                -webkit-animation: moveTop 8s infinite linear;
                pre {
                  padding: 5px 0;
                }
              }
              @-webkit-keyframes moveTop {
                0% {
                  transform: translateY(0);
                }
                100% {
                  transform: translateY(-100%);
                }
              }
            }
          }
        }
        .rebort-response {
          overflow: hidden;
          padding: 5px;
          .rebort-response-left {
            float: left;
            display: inline-block;
            background: #409EFF;
            padding: 5px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 35px;
            img {
              width: 30px;
              height: 30px;
              vertical-align: middle;
              display: inline-block;
            }
          }
          .rebort-response-right {
            margin-left: 70px;
            box-shadow: 0 3px 12px 0 rgba(198,203,222,.45);
            border-radius: 4px;
            text-align: left;
            background: #fff;
            padding: 15px;
            max-height: 50vh;
            overflow-y: auto;
            position: relative;
            .el-radio {
              margin-bottom: 10px;
              margin-right: 0;
              width: 250px;
            }
            .madols {
              position: absolute;
              top: 0;
              left: 0;
              background: rgba(251, 251, 251, 0.5);
              width: 100%;
              height: 100%;
              text-align: center;
              p {
                position: relative;
                top: 50%;
                margin-top: -11px;
                color: #409EFF;
              }
            }
          }
        }
        .question-content-footer {
          left: 50%;
          bottom: 0px;
          margin-top: 15px;
          width: 100%;
          position: absolute;
          bottom: 0;
          text-align: center;
          transform: translateX(-50%);
          p {
            //text-align: center;
            font-size: 12px;
            color: #7b7b7b;
            span {
              color: #409EFF;
            }
          }
        }
      }
    }
    .qc-version{
      text-align: left;
    }

    .loading-wrap {
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, .8);
      z-index: 100;
      .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -mos-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align:center;
      /* disable selection and cursor changes */
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
      }

      /* Text align it the center of screen and connect the looped animation for 2 seconds */
      .text{
        position: absolute;
        left: -1.3em;
        top: -1.7em;
        -webkit-animation: text 2s infinite;
        -moz-animation: text 2s infinite;
        -moz-animation: text 2s infinite;
        -ms-animation: text 2s infinite;
        -o-animation: text 2s infinite;
        animation: text 2s infinite;
      }

      /* Set for the first layer vertical position */
      .vertical{
        position:absolute;
        top: -1.84em;
        left: -0.4em;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
      }

      /* Set for the second layer horizontal position */
      .horizontal{
        position:absolute;
        top:0em;
        left:0em;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      /* The next two classes do mirror for animation */
      .circlesup{
        position:absolute;
        top: -4.7em;
        right: 12.1em;
      }

      .circlesdwn{
        position:absolute;
        top:2.5em;
        right:-13.5em;
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        transform: rotate(180deg);
      }

      /* Create a container for our circles, rotate it 45 degrees and set animation*/
      .circle {
        position: absolute;
        width: 15em;
        height: 15em;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
        -webkit-animation: orbit 2s infinite;
        -moz-animation: orbit 2s infinite;
        -moz-animation: orbit 2s infinite;
        -ms-animation: orbit 2s infinite;
        -o-animation: orbit 2s infinite;
        animation: orbit 2s infinite;
        z-index:5;
      }

      /* Style's of our circles */
      .circle:after {
        content: '';
        position: absolute;
        width: 2em;
        height: 2em;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        -ms-border-radius: 100%;
        -o-border-radius: 100%;
        border-radius: 100%;
        background: #409EFF; /* Pick a color 1*/
      }

      .circle:nth-child(2) {
        -webkit-animation-delay: 100ms;
        -moz-animation-delay: 100ms;
        -ms-animation-delay: 100ms;
        -o-animation-delay: 100ms;
        animation-delay: 100ms;
        z-index:4;
      }

      .circle:nth-child(2):after  {
        background: #79d4ee; /* Pick a color 2*/
        -webkit-transform: scale(0.8,0.8);
        -moz-transform: scale(0.8,0.8);
        -ms-transform: scale(0.8,0.8);
        -o-transform: scale(0.8,0.8);
        transform: scale(0.8,0.8);
      }

      .circle:nth-child(3) {
        -webkit-animation-delay: 225ms;
        -moz-animation-delay: 225ms;
        -ms-animation-delay: 225ms;
        -o-animation-delay: 225ms;
        animation-delay: 225ms;
        z-index:3;
      }

      .circle:nth-child(3):after  {
        background: #f4d3b0; /* Pick a color 3*/
        -webkit-transform: scale(0.6,0.6);
        -moz-transform: scale(0.6,0.6);
        -ms-transform: scale(0.6,0.6);
        -o-transform: scale(0.6,0.6);
        transform: scale(0.6,0.6);
      }

      .circle:nth-child(4) {
        -webkit-animation-delay: 350ms;
        -moz-animation-delay: 350ms;
        -ms-animation-delay: 350ms;
        -o-animation-delay: 350ms;
        animation-delay: 350ms;
        z-index:2;
      }

      .circle:nth-child(4):after  {
        background: #ff6d37; /* Pick a color 4*/
        -webkit-transform: scale(0.4,0.4);
        -moz-transform: scale(0.4,0.4);
        -ms-transform: scale(0.4,0.4);
        -o-transform: scale(0.4,0.4);
        transform: scale(0.4,0.4);
      }

      .circle:nth-child(5) {
        -webkit-animation-delay: 475ms;
        -moz-animation-delay: 475ms;
        -ms-animation-delay: 475ms;
        -o-animation-delay: 475ms;
        animation-delay: 475ms;
        z-index:1;
      }

      .circle:nth-child(5):after  {
        background: #DB2F00; /* Pick a color 5*/
        -webkit-transform: scale(0.2,0.2);
        -moz-transform: scale(0.2,0.2);
        -ms-transform: scale(0.2,0.2);
        -o-transform: scale(0.2,0.2);
        transform: scale(0.2,0.2);
      }

      /* Animation keys */
      @-webkit-keyframes orbit {
        0%		{ -webkit-transform:rotate(45deg); }

        5%		{ -webkit-transform:rotate(45deg);
              -webkit-animation-timing-function: ease-out; }

        70% { -webkit-transform:rotate(405deg);
              -webkit-animation-timing-function: ease-in; }

        100%	{ -webkit-transform:rotate(405deg); }
      }

      @-moz-keyframes orbit {
        0%		{ -moz-transform:rotate(45deg); }

        5%		{ -moz-transform:rotate(45deg);
              -moz-animation-timing-function: ease-out; }

        70%		{ -moz-transform:rotate(405deg);
              -moz-animation-timing-function: ease-in; }

        100%	{ -moz-transform:rotate(405deg); }
      }
      @-ms-keyframes orbit {
        0%		{ -ms-transform:rotate(45deg); }

        5%		{ -ms-transform:rotate(45deg);
              -ms-animation-timing-function: ease-out; }

        70%		{ -ms-transform:rotate(405deg);
              -ms-animation-timing-function: ease-in; }

        100%	{ -ms-transform:rotate(405deg); }
      }

      @-o-keyframes orbit {
        0%		{ -o-transform:rotate(45deg); }

        5%		{ -o-transform:rotate(45deg);
              -o-animation-timing-function: ease-out; }

        70%		{ -o-transform:rotate(405deg);
              -o-animation-timing-function: ease-in; }

        100%	{ -o-transform:rotate(405deg); }
      }

      @keyframes orbit {
        0%		{ transform:rotate(45deg); }

        5%		{ transform:rotate(45deg);
              animation-timing-function: ease-out; }

        70% 	{ transform:rotate(405deg);
              animation-timing-function: ease-in; }

        100%	{ transform:rotate(405deg); }
      }

      @-webkit-keyframes text {
        0%		{-webkit-transform:scale(0.2,0.2);
            -webkit-animation-timing-function: ease-out; }

        40%,60%{ -webkit-transform:scale(1,1);
              -webkit-animation-timing-function: ease-out;  }

        70%,100%{ -webkit-transform:scale(0.2,0.2);  }
      }

      @-moz-keyframes text {
        0%		{-moz-transform:scale(0.2,0.2);
            -moz-animation-timing-function: ease-out; }

        50%		{ -moz-transform:scale(1,1);
              -moz-animation-timing-function: ease-out;  }

        60%		{ -moz-transform:scale(1,1);
            -moz-animation-timing-function: ease-out;  }

        100%	{ -moz-transform:scale(0.2,0.2);  }
      }

      @-mos-keyframes text {
        0%		{-mos-transform:scale(0.2,0.2);
            -mos-animation-timing-function: ease-out; }

        50%		{ -mos-transform:scale(1,1);
              -mos-animation-timing-function: ease-out;  }

        60%		{ -mos-transform:scale(1,1);
              -mos-animation-timing-function: ease-out;  }

        100%	{ -mos-transform:scale(0.2,0.2);  }
      }

      @-o-keyframes text {
        0%		{ -o-transform:scale(0.2,0.2);
              -o-animation-timing-function: ease-out; }

        50%		{ -o-transform:scale(1,1);
              -o-animation-timing-function: ease-out;  }

        60%		{ -o-transform:scale(1,1);
              -o-animation-timing-function: ease-out;  }

        100%	{ -o-transform:scale(0.2,0.2);  }
      }

      @keyframes text {
        0%		{ transform:scale(0.2,0.2);
              animation-timing-function: ease-out; }

        50%		{ transform:scale(1,1);
              animation-timing-function: ease-out;  }

        60%		{ transform:scale(1,1);
              animation-timing-function: ease-out;  }

        100%	{ transform:scale(0.2,0.2);  }
      }
    }
    .report-visible-wrap {
      h2 {
        text-align: center;
        margin-top: -30px;
        margin-bottom: 20px;
      }
      pre {
        white-space: pre-wrap;
      }
    }
  }
  .step-wrap {
    .step-title {
      position: relative;
      img {
        width: 100%;
      }
      h4 {
        position: absolute;
        top: 39px;
        right: 55px;
        font-size: 16px;
      }
    }
    .step-content {
      position: relative;
      overflow: hidden;
      margin-top: -27px;
      padding: 20px 36px;
      ul {
        margin: 0 auto;
        li {
          margin-top: 20px;
          &:nth-child(1) .step-content-left {
            background: #0c1059;
          }
          &:nth-child(2) .step-content-left {
            background: #a74bd4;
          }
          &:nth-child(3) .step-content-left {
            background: #df7ce6;
          }
          &:nth-child(4) .step-content-left {
            background: #e39c64;
          }
          &:nth-child(5) .step-content-left {
            background: #797979;
          }
          .step-content-left {
            float: left;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            z-index: 99;
            position: relative;
            transform: rotate(45deg);
            margin: 5px 0;
            color: #fff;
            h5 {
              transform: rotate(-45deg);
            }
          }
          .step-content-right {
            padding-left: 50px;
            p {
              color: #333;
              font-size: 14px;
              line-height: 30px;
              border-bottom: 1px solid #ddd;
              padding: 5px 0;
            }
          }
        }
      }
      img {
        position: absolute;
        left: 48px;
        width: 5px;
      }
    }
  }
  .ghostClass{
    display: none !important;
  }
  .chosenClass{
    visibility: hidden;
    display: inline-block !important;
    //margin-bottom: 0px !important;
    //float: none;
    background-color: powderblue !important;
    opacity: 1!important;
  }
  .dragClass{
    //float: none;
    visibility: visible !important;
    margin-bottom: 0px !important;
    //position: absolute !important;
    //display: inline-block !important;
    //background-color: blueviolet !important;
    opacity: 1 !important;
    box-shadow:none !important;
    outline:none !important;
    background-image:none !important;
  }
  .itxst{
    margin: 10px;
  }
  .title{
    padding: 6px 12px;
  }
  .col{
    width: 40%;
    flex: 1;
    padding: 10px;
    border: solid 1px #eee;
    border-radius:5px ;
    float: left;
    background-color: lightblue;
    display: inline-block;
    margin-top: 10px;
  }
  //.col+.col{
  //  margin-left: 10px;
  //}
  .item{
    //flex-direction: column;
    //display: inline-block;
    float: left;
    //horiz-align: center;
    //padding: 5px;
    //border: solid 1px #eee;
    //background-color: #f1f1f1;
    white-space: nowrap;
    width: 17%;
    margin-bottom: 5%;
    cursor: move;
    //margin-left: 10px;
    //margin-top: 10px;
    font-size: 1px;
  }
  .itemRight{
     //flex-direction: column;
     //display: inline-block;
     float: left;
     //horiz-align: center;
     //padding: 5px;
     //border: solid 1px #eee;
     //background-color: #f1f1f1;
     white-space: nowrap;
     width: 17%;
     cursor: move;
     //margin-left: 10px;
     //margin-top: 10px;
     font-size: 1px;
   }
  .itemRightDouble{
    //flex-direction: column;
    //display: inline-block;
    float: left;
    //horiz-align: center;
    //padding: 5px;
    //border: solid 1px #eee;
    //background-color: #f1f1f1;
    white-space: nowrap;
    width: 17%;
    cursor: move;
    //margin-left: 10px;
    //margin-top: 10px;
    font-size: 1px;
  }
  //.item:hover{
  //  background-color: #fdfdfd;
  //}
  .tag{
    display: inline-block;
    padding: 6px 12px;
    font-size: 12px;
    margin-right: 15px;
    margin-bottom: 10px;
    color: #999;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 1px 2px rgba(0,0,0,.05);
    overflow: hidden;
    cursor: pointer;
  }
  .domainsLabel{
    display: inline-block;
    padding: 6px 12px;
    font-size: 15px;
    margin-right: 15px;
    margin-bottom: 10px;
    background: #fff;
    //border-radius: 16px;
    //box-shadow: 0 1px 2px rgba(0,0,0,.05);
    overflow: hidden;
    cursor: pointer;
    border-bottom-width: 2px;
    border-style: solid;
    border-bottom-color: white;
    //border-width: 1px;
    //border-color: #3a8ee6;
  }
  .card{
    width: 30px;
    height: 30px;
    horiz-align: center;
  }
  .hide{
    display: none;
  }
  .hideOver{
    flex: 1;display: flex;overflow: hidden visible;margin-left: 10%;width: 80%
  }
  .hideOver::-webkit-scrollbar{
    width: 0px;
    /* display: none; */
    height: 5px;
  }
  #questionHint{
    margin: -20px 0 20px 0;
  }
  .analyze-state-display svg{
    width: 10%;
    height: auto;
    animation: rounding 2s ease-in-out infinite;
  }
  @keyframes rounding {
    100%{
      transform: rotateZ(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/Question.vue